import { hasKey, t } from './t';

// intervalNoun translates a billing interval ("month") in the count's plural
// form via the shared interval.* catalog keys, falling back to the raw server
// value for an interval the catalog doesn't know.
export function intervalNoun(interval: string, n: number): string {
  const key = `interval.${interval}`;
  return hasKey(key) ? t(key, { n }) : interval;
}

// cadenceLabel is the translated billing cadence: "per month", "every 3 months".
export function cadenceLabel(interval: string, count: number): string {
  if (count <= 1) {
    return t('paywall.intervalPer', { interval: intervalNoun(interval, 1) });
  }
  return t('paywall.intervalEvery', { n: count, count, interval: intervalNoun(interval, count) });
}
